import type { Prototype } from "../prototype-types";

export const tonyChenPrototypes: Prototype[] = [
  {
    id: "first-order-incentive-tiering",
    name: "First Order Incentive Tiering",
    path: "/tc/first-order-incentive-tiering",
    description:
      "Explores adding a higher tier to the first-order welcome offer: keep 50% off up to $100 as the baseline, and unlock up to $150 off when a retailer adds 3+ brands and purchases. Shows the change across the post-signup modal, homepage tile, carts view, and checkout order summary via a Baseline/Tiered toggle.",
    owner: "Tony Chen",
    createdAt: "2026-07-08",
    lastUpdated: "2026-07-08",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    creationTool: "cursor",
    thumbnail:
      "https://cdn.faire.com/fastly/b32a1238fa12cf0731e50a0b50548449081d7a672e74951f92e8565a7435d8cd.png",
  },
  {
    id: "collecting-opening-soon-phone-number",
    name: "Collecting Opening Soon Phone Number",
    path: "/tc/collecting-opening-soon-phone-number",
    description:
      "Optional phone number step for Opening Soon retailer signup (#ft-os-ask-phone-numbers). Six short copy variants (A–E + original) via VariantSwitcher. Mock-only.",
    owner: "Tony Chen",
    createdAt: "2026-05-14",
    lastUpdated: "2026-05-14",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    creationTool: "cursor",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/e8c65db24b03f6fc5fb9e5f99aec5615aac7061e3e995f0f3c3750024d67d412.png",
  },
  {
    id: "nux-category-selector",
    name: "NUX Category Selector",
    path: "/tc/nux-category-selector",
    description:
      "Hierarchical category selector for retailer signup, allowing multi-select at different category levels.",
    owner: "Tony Chen",
    createdAt: "2026-03-17",
    lastUpdated: "2026-03-17",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/a19e9d859e720ca2ec733368cded8cbff9064283eaab4b871e424adb7d86f40e.png",
    figmaLink:
      "https://www.figma.com/design/Mq8lyxQ7jcFBoMhFrJyjVG/NUX-Discovery?node-id=3200-5422",
    creationTool: "cursor",
  },
  {
    id: "tc-magic-signup",
    name: "Magic Signup from Email Domain",
    path: "/tc/magic-signup",
    description:
      "Retailer signup with 'magic' pre-fill from the email domain (PR-5154). Business type comes before the lookup beat. Places and website-only results use a single 'We found your store' confirmation; accepting skips business name, while declining follows the standard flow. Includes the production Opening Soon date and brick-and-mortar budget path. Mock-only.",
    owner: "Tony Chen",
    createdAt: "2026-08-03",
    lastUpdated: "2026-08-24",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/tc-magic-signup.png",
    creationTool: "cursor",
  },
  {
    id: "tc-welcome-brand-matches",
    name: "Welcome Page Brand Matches",
    path: "/tc/welcome-brand-matches",
    description:
      "Standalone signup moment for scraped brand matches, with layout and 3 / 4 / 5 / 6 / 8+ coverage variants. Sequences into today's congratulations page with no brand-match section. On-congratulations treatments are a mutually exclusive alternative.",
    owner: "Tony Chen",
    createdAt: "2026-10-01",
    lastUpdated: "2026-10-12",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/tc-welcome-brand-matches.png",
    creationTool: "cursor",
  },
  {
    id: "tc-personalized-clickable-foi-banner",
    name: "Personalized Clickable FOI Banner",
    path: "/tc/personalized-clickable-foi-banner",
    description:
      "Explore a finer-grained, personalized FOI top banner with clickable category links and SQST fallback behavior.",
    owner: "Tony Chen",
    createdAt: "2026-10-12",
    lastUpdated: "2026-10-12",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/5eee8eaa2209e542cbbc751ff2319065d3c227ccd6a585e1cb1746fabc6ffdaf.png",
    creationTool: "cursor",
    project: "Personalized Clickable FOI Banner",
  },
  {
    id: "tc-revamped-fd-signup",
    name: "Revamped FD Signup",
    path: "/tc/revamped-fd-signup",
    description:
      "A focused Faire Direct signup exploration testing brand-aware Personal Info copy, a control-like brand-relationship step, and visual treatments for the Dandylion offer modal.",
    owner: "Tony Chen",
    createdAt: "2026-10-12",
    lastUpdated: "2026-10-13",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    thumbnail: "/images/thumbnails/tc-revamped-fd-signup.png",
    creationTool: "cursor",
    project: "FD Signup",
  },
];
